(function () {
  console.log("Collection Filters");

  var createId = function () {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return "_" + Math.random().toString(36).substr(2, 9);
  };

  Vue.component("availability-filter", {
    template: `
    <li v-on:mouseleave="closeOpen" class="filter-item relative px-3 order-last">
      <button v-on:click="toggleOpen" v-on:mouseenter="toggleOpen" class="filter-item-style  font-bold font-xs uppercase" aria-controls="" aria-expanded="" type="button">{{label}}</button>
      <div :class="open ? 'filter-drop bg-white absolute top-full left-0' : 'filter-drop hidden' " id="">
        <ul class="filter-values-list p-2 m-0 w-full">
          <li class="filter-item cursor-pointer w-full flex justify-start items-center font-normal text-sm pb-2">
            <input v-on:change="onChange" id="rts" type="checkbox" v-model="selected" value="ready-to-ship" />
            <label for="rts" class="mb-0 pl-2 cursor-pointer">Ready to Ship {{ countProductsAreAvailable() > 0 ? '(' + countProductsAreAvailable() + ')' : ''}}</label>
          </li> 
        </ul>
      </div>
    </li>
    `,
    props: {
      label: {
        type: String,
        required: false,
      },
    },
    data() {
      return {
        open: false,
        selected: [],
      };
    },
    watch: {},
    computed: {},
    methods: {
      closeOpen() {
        this.open = false;
      },
      countProductsAreAvailable() {
        const { items = [] } = this.$parent;

        const count = items.reduce((count, item) => {
          const { variants } = item;

          const hasAvailableVariant = variants.some(
            ({ inventory_management, inventory_quantity }) =>
              inventory_management === "shopify" && inventory_quantity > 0
          );

          return (count += hasAvailableVariant ? 1 : 0);
        }, 0);

        return count;
      },
      toggleOpen() {
        this.open = !this.open;
      },
      onChange(event) {
        console.log("Filter Change:", this.selected);
        this.$emit("filter-change", {
          selected: this.selected.includes("ready-to-ship"),
        });
      },
    },
    mounted() {
      console.log("Mount Availability Filter");
    },
  });

  Vue.component("tag-filter", {
    template: document.querySelector("script[data-tag-item-template]")
      .innerHTML,
    props: {
      allTags: {
        type: Array,
        required: false,
        default() {
          return [];
        },
      },
      label: {
        type: String,
        required: false,
      },
      phrase: {
        type: String,
        required: false,
      },
    },
    data() {
      return {
        open: false,
        selected: [],
        values: [],
        tags: this.allTags,
      };
    },
    watch: {},
    computed: {
      availableTags() {
        return [...this.allTags].filter((tag) => {
          let test = new RegExp("^" + this.phrase, "i");

          return test.test(tag);
        });
      },
    },
    methods: {
      phraseRemover(value, phrase) {
        const test = new RegExp(phrase, "ig");

        return value.replace(test, "").replace("-and-", " & ");
      },
      countProductsWithTag(tag) {
        const { items = [] } = this.$parent;

        const count = items.reduce((count, item) => {
          return (count += item.tags.includes(tag) ? 1 : 0);
        }, 0);

        // console.log("COUNT PRODUCT TAGS:", this, count);

        return count;
      },
      closeOpen() {
        this.open = false;
      },
      toggleOpen() {
        this.open = !this.open;
      },
      onChange(event) {
        this.$emit("filter-change", {
          phrase: this.phrase,
          tags: this.selected,
        });
      },
    },
    mounted() {
      let values = [...this.allTags].filter((tag) => {
        let test = new RegExp("^" + this.phrase, "i");

        return test.test(tag);
      });

      this.values = [...values];

      window.addEventListener("scroll", () => (this.open = false));

      this.$parent.$on("clear-filters", () => {
        this.selected = [];
      });

      // console.log("Tag Mixin:;", this, this.test());
    },
  });

  Vue.component("native-filter", {
    template: document.querySelector("script[data-native-filter-item-template]")
      .innerHTML,
    props: {
      label: {
        type: String,
        required: true,
      },
      name: {
        type: String,
        required: false,
      },
      values: {
        type: String,
        required: false,
      },
      prefix: {
        type: String,
        required: false,
      },
    },
    data() {
      return {
        selected: [],
        open: false,
      };
    },
    computed: {
      availableValues() {
        if (this.prefix)
          return this.values.split(",").reduce((values, filterValue) => {
            const [label, value, count, active] = filterValue.split("|");

            const prefixExp = new RegExp(this.prefix, "ig");

            if (value.startsWith(this.prefix))
              values.push({
                label: label.replace(prefixExp, "") + ` (${count})`,
                value,
              });

            return values;
          }, []);

        let values = this.values.split(",").map((filterValue) => {
          const [label, value, count, active] = filterValue.split("|");

          return {
            label: label + ` (${count})`,
            value,
          };
        });

        if (this.name === "filter.v.option.color") {
          const desiredOrder = ["Yellow Gold", "White Gold", "Rose Gold"].map(
            (str) => str.toLowerCase()
          );

          return values
            .sort(
              (a, b) =>
                desiredOrder.indexOf(a.label.toLowerCase()) -
                desiredOrder.indexOf(b.label.toLowerCase())
            )
            .reverse();
        }

        return values;
      },
    },
    methods: {
      closeOpen() {
        this.open = false;
      },
      toggleOpen(event) {
        if (window.innerWidth < 768 && event.type === "mouseenter") return;
        console.log("Toggle Open:", event.type, this.open);

        this.open = !this.open;
      },
      onChange(event) {
        console.log("onChange:", this.name);

        this.$emit("filter-change", {
          type: this.name,
          value: this.selected,
        });
      },
    },
    mounted() {
      const activeValues = this.values
        .split(",")
        .reduce((values, filterValue) => {
          const [label, value, count, active] = filterValue.split("|");

          if (active === "true") values.push(value);

          return values;
        }, []);

      this.selected = [...activeValues];

      this.$parent.$on("clear-filters", () => {
        console.log("Clear native filters!");
        this.selected = [];
      });

      window.addEventListener("scroll", () => {
        if (window.innerWidth > 768) this.open = false;
      });
    },
  });

  Vue.component("variant-filter", {
    template: document.querySelector(
      "script[data-variant-filter-item-template]"
    ).innerHTML,
    props: {
      label: {
        type: String,
        required: false,
      },
      name: {
        type: String,
        required: false,
      },
      values: {
        type: Array,
        required: false,
      },
    },
    data() {
      return {
        open: false,
        selected: [],
      };
    },
    computed: {},
    methods: {
      closeOpen() {
        this.open = false;
      },
      toggleOpen() {
        this.open = !this.open;
      },
      onChange(event) {
        console.log("onChange:", this.name);

        this.$emit("filter-change", {
          type: this.name,
          value: this.selected,
        });
      },
    },
    mounted() {
      console.log("Variant filter mount", this.values);

      this.$parent.$on("clear-filters", () => {
        this.selected = [];
      });
      window.addEventListener("scroll", () => (this.open = false));
    },
  });

  Vue.component("filter-item", {
    template: document.querySelector("script[data-filter-item-template]")
      .innerHTML,
    props: {
      attribute: {
        type: String,
        required: false,
      },
      label: {
        type: String,
        required: false,
      },
      values: {
        type: Array,
        required: false,
      },
    },
    data() {
      return {
        open: false,
        selected: [],
      };
    },
    computed: {
      inquireForPricing() {
        return false;
      },
    },
    methods: {
      closeOpen() {
        this.open = false;
      },
      toggleOpen() {
        this.open = !this.open;
      },
      onChange(event) {
        this.$emit("filter-change", {
          type: this.attribute,
          value: this.selected,
        });
      },
    },
    mounted() {
      this.$parent.$on("clear-filters", () => {
        this.selected = [];
      });
      window.addEventListener("scroll", () => (this.open = false));
    },
  });

  Vue.component("sort-grid", {
    template: document.querySelector("script[data-sort-item-template]")
      .innerHTML,
    props: {
      attribute: {
        type: String,
        required: false,
      },
      label: {
        type: String,
        required: false,
      },
      values: {
        type: Array,
        required: false,
        default: [],
      },
    },
    data() {
      return {
        open: false,
        selected: null,
      };
    },
    computed: {
      inquireForPricing() {
        return false;
      },
    },
    methods: {
      skip(value) {
        const skipValues = [
          "title-ascending",
          "title-descending",
          "manual",
          "best-selling",
          "created-ascending",
        ];

        return skipValues.includes(value);
      },
      closeOpen() {
        this.open = false;
      },
      toggleOpen(event) {
        if (window.innerWidth < 768 && event.type === "mouseenter") return;

        this.open = !this.open;
      },
      rename(label) {
        if (label === "Date, new to old") return "Newest";

        return label;
      },
      handleClick(event) {
        const selected = this.selected;
        const input = event.target.previousElementSibling;
        const same = selected === input.value;

        if (same) {
          console.log("This is same!");
          this.selected = null;
          console.log("Post Selected:", this.selected);
        }
      },
      onChange(event) {
        event.preventDefault();
        this.selected =
          this.selected === event.target.value ? null : event.target.value;
        console.log("Change sort:", event.target.value, this.selected);
        // this.$emit("sort-change", {
        //   value: this.selected,
        // });
        this.triggerFormInput();
      },
      triggerFormInput() {
        const { form } = this.$parent.$refs;

        if (form) form.dispatchEvent(new CustomEvent("input"));
      },
    },
    mounted() {
      console.log(
        "MountSort:",
        this.values,
        window.theme.collection_details.sort
      );

      this.$parent.$on("clear-filters", () => {
        this.selected = [];
      });

      window.addEventListener("scroll", () => {
        if (window.innerWidth > 768) this.open = false;
      });
    },
  });

  // console.log("Test collection", window.theme.collection_details.sort);
  const defaultFilters = {
    attribute: null,
    price: null,
    tags: null,
    readyToShip: false,
    variants: {},
  };

  Vue.mixin({
    methods: {
      test() {
        // console.log("Test Mixin", this, this.$parent.items);
      },
    },
  });

  const debounce = (fn, wait = 300) => {
    let t;
    return (...args) => {
      clearTimeout(t), (t = setTimeout(() => fn.apply(this, args), wait));
    };
  };

  const sleep = (ms = 300) => new Promise((resolve) => setTimeout(resolve, ms));

  var app = new Vue({
    el: "#collection",
    data: {
      scrollY: 0,
      scTimer: 0,
      filtersOpen: window.innerWidth > 768,
      page: 1,
      wishlist_items: [],
      loading: false,
      abortController: null,
      activeFilters: {
        ...defaultFilters,
      },
      sort_by: null,
      sortOptions: [...window.theme.collection_details.sort],
      collection_details: { ...window.theme.collection_details },
      items: [...window.theme.collection_details.products].map((item) => ({
        ...item,
        show: true,
      })),
      anyFiltersActive: false,
    },
    computed: {
      availableTags() {
        let values = [...window.theme.collection_details.all_tags];

        let tagsInItems = [...values].filter((tag) => {
          return [...this.items].find((product, index) => {
            if (!product.show) return false;

            return product.tags.includes(tag);
          });
        });

        // console.log("Tags In Items:", tagsInItems);

        return [...tagsInItems];
      },
      // anyFiltersActive() {
      //   const { attribute, price, tags, variants } = this.activeFilters;

      //   const variantFilterIsActive = Object.keys(variants).some(
      //     (key) => variants[key].length > 0
      //   );

      //   return (
      //     Boolean(attribute) ||
      //     Boolean(price) ||
      //     Boolean(tags) ||
      //     variantFilterIsActive
      //   );
      // },
      isEmpty() {
        const isEmpty = this.items.every((item) => !item.show);

        // console.log("Is empty:", { isEmpty, items: this.items });

        return isEmpty;
      },
      totalPages() {
        return Math.ceil(this.items.length / 32);
      },
      activeWishlistIds() {
        return this.wishlist_items.map((item) => item.empi);
      },
      productTypes() {
        const allTypesFromItems = [
          ...new Set([...this.items].map(({ type }) => type)),
        ];

        return [...window.theme.collection_details.all_types]
          .filter(
            (type) =>
              type !== "" && type !== window.theme.collection_details.title
          )
          .filter((type) => {
            return allTypesFromItems.includes(type);
          });
      },
    },
    watch: {
      activeFilters() {
        const products = [...this.items];

        this.items = products.map((product) => {
          const qualifies =
            this.isAttributeQualified(product) &&
            this.isTagQualified(product) &&
            this.isVariantQualified(product) &&
            this.isPriceQualified(product) &&
            this.isAvailabilityQualified(product);

          product.show = qualifies;

          // console.log("SHOW?:", product.show, {
          //   attribute: this.isAttributeQualified(product),
          //   tag: this.isTagQualified(product),
          //   variant: this.isVariantQualified(product),
          //   price: this.isPriceQualified(product),
          //   available: this.isAvailabilityQualified(product),
          // });

          return product;
        });

        setTimeout(() => {
          if (
            this.anyFiltersActive &&
            document.documentElement.scrollTop > 75
          ) {
            this.scrollToEl(document.querySelector(".product-item"));
          }
        }, 300);
      },
      sort_by() {
        console.log(
          "sortByChange:",
          this.sort_by,
          this.items[0].created_at,
          new Date(this.items[0].created_at)
        );
        switch (this.sort_by) {
          case "title-ascending":
            this.items = this.items.sort((a, b) =>
              a.title.localeCompare(b.title)
            );
            break;

          case "title-descending":
            this.items = this.items.sort((a, b) =>
              b.title.localeCompare(a.title)
            );
            break;

          case "created-ascending":
            this.items = this.items.sort(
              (a, b) => new Date(a.created_at) - new Date(b.created_at)
            );
            break;

          case "created-descending":
            this.items = this.items.sort(
              (a, b) => new Date(b.created_at) - new Date(a.created_at)
            );
            break;

          case "price-descending":
            this.items = this.items.sort((a, b) => b.price - a.price);
            break;

          case "price-ascending":
            this.items = this.items.sort((a, b) => a.price - b.price);
            break;
        }
      },
      page: {
        handler() {
          setTimeout(() => {
            // zonos.config(z_store);
          }, 500);
        },
        flush: "post",
      },
    },
    methods: {
      formParamsAsString(form) {
        const formData = new FormData(form);

        return new URLSearchParams(formData).toString();
      },
      async handleFilterInput(event) {
        console.log("changed Input:", event.target);

        if (event.target.name === "price") {
          await sleep(300);
        }

        const $form = this.$refs.form;
        const paramsAsString = this.formParamsAsString($form);

        const $checkeds = $form.querySelectorAll("input:checked");

        const $hasActiveFilter = Array.from($checkeds).some(($input) => {
          if ($input.name.indexOf("price") === -1) return $input.checked;

          // price filter. You dont want to count 'all';

          if ($input.value === "All") return false;

          return true;
        });

        this.anyFiltersActive = $hasActiveFilter;
        console.log("Form Filter Input", $form, {
          url: paramsAsString,
          $checkeds,
        });

        this.loading = true;
        const data = await this.fetchFilteredPageProducts(`${paramsAsString}`);

        const { products } = data;

        this.items = [...products].map((product) => ({
          ...product,
          show: true,
        }));

        this.loading = false;
        // const $temp = document.createElement("div");
        // $temp.innerHTML = data;

        // const $collection = $temp.querySelector("#collection");

        // document.querySelector("#collection").innerHTML = $collection.innerHTML;

        console.log({ data });
      },

      fetchFilteredPageProducts(search, sectionId) {
        if (this.abortController) {
          this.abortController.abort();
        }

        this.abortController = new AbortController();

        return fetch(
          `${window.location.pathname}?${search}&view=filters-source`
        )
          .then((res) => res.json())
          .then((html) => {
            this.updateUrl(
              `${window.location.origin}${window.location.pathname}?${search}`
            );

            this.abortController = null;

            return html;
          });
      },

      updateUrl(url) {
        // Create a URL object for the current page's URL
        const currentUrl = new URL(window.location.href);

        // Create a URL object for the new URL string
        const newUrl = new URL(url);

        // Get the search parameters from the new URL
        const newSearchParams = newUrl.searchParams;

        // Loop through the parameters in the new URL and update the current URL's parameters
        newSearchParams.forEach((value, key) => {
          if (value !== undefined && value !== null) {
            // Set or update the parameter in the current URL
            currentUrl.searchParams.set(key, value);
          } else {
            // Remove the parameter from the current URL if the value is undefined or null
            currentUrl.searchParams.delete(key);
          }
        });

        currentUrl.searchParams.forEach((value, key) => {
          if (!newSearchParams.has(key)) currentUrl.searchParams.delete(key);
        });

        console.log({ url, newSearchParams, currentUrl });

        // Update the URL in the address bar using history API
        window.history.pushState(
          { path: currentUrl.href },
          "",
          currentUrl.href
        );
      },
      variantOptionValues(name) {
        const values = this.items.reduce((values, item) => {
          const { options } = item;
          const optionName = Object.keys(options).find(
            (opt) => opt.toLowerCase() === name.toLowerCase()
          );

          if (!optionName) return values;

          return [...new Set([...values, ...options[optionName]])];
        }, []);

        return values.sort((a, b) => a.localeCompare(b));
      },
      scrollToEl($el) {
        var element = $el;
        var headerOffset = 180;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      },
      handleAutoClick(event) {
        this.page = this.page + 1;
      },
      isActiveIndex(index) {
        if (this.anyFiltersActive) return true;

        return index < this.page * 32;
      },
      isAvailabilityQualified(product) {
        if (!this.activeFilters.readyToShip) return true;

        const { variants } = product;
        const quantities = variants.map(
          ({ inventory_quantity }) => inventory_quantity
        );

        return variants.some(
          ({ inventory_management, inventory_quantity }) =>
            inventory_management === "shopify" && inventory_quantity > 0
        );
      },
      isAttributeQualified(product) {
        const attributeFilters = this.activeFilters.attribute || {};

        const activeKeys = Object.keys(attributeFilters).filter((key) =>
          Boolean(attributeFilters[key])
        );

        if (activeKeys.length === 0) return true;

        return [...activeKeys].find((key) => {
          return attributeFilters[key].includes(product[key]);
        });
      },
      isVariantQualified(product) {
        const productOptions = product.options;
        const filters = this.activeFilters.variants;
        const options = Object.keys(filters);
        const intersects = (a, b) => a.some((x) => b.includes(x));

        if (options.length === 0) return true;

        const matchesAnyVariantFilter = options.every((optionName) => {
          const values = filters[optionName];

          if (values.length === 0) return true; // no values, so it passes.

          const productHasOption = Object.keys(productOptions).find(
            (pOption) => pOption.toLowerCase() === optionName.toLowerCase()
          );
          if (!productHasOption) return false; // product does not have option -> fail.

          const productOptionValues = productOptions[productHasOption].map(
            (val) => val.toLowerCase()
          );
          const filterValues = values.map((val) => val.toLowerCase());

          return intersects(productOptionValues, filterValues);
        });

        return matchesAnyVariantFilter;
      },
      isPriceQualified(product) {
        const priceFilter = this.activeFilters.price;

        if (!priceFilter) return true;

        const { price } = product;
        const { min, max } = priceFilter;

        if (max == -1) {
          return min < price;
        }

        return price < max && price > min;
      },
      isTagQualified(product) {
        const tagFilters = this.activeFilters.tags || [];

        if (tagFilters.length === 0) return true;

        return [...tagFilters].find((tag) => {
          return product.tags.includes(tag);
        });
      },
      clearFiltersHandler() {
        this.activeFilters = {
          attribute: null,
          price: null,
          tags: null,
          readyToShip: false,
          variants: {},
        };

        const { form } = this.$refs;

        console.log(
          "ClearFilters:",
          this.activeFilters,
          defaultFilters,
          this.$refs
        );

        this.toggleFilterBar();

        this.$emit("clear-filters");

        setTimeout(() => {
          form.dispatchEvent(new CustomEvent("input"));
        }, 200);
      },
      handleSortUpdate({ value }) {
        this.sort_by = value;
        console.log("handleSortUpdate:", value);
      },
      handlePriceUpdate({ value }) {
        let currentFilters = { ...this.activeFilters };
        let priceFilter = currentFilters.price || {};

        if (!value) {
          priceFilter = null;
          this.activeFilters = {
            ...currentFilters,
            price: priceFilter,
          };

          return;
        }

        const { min, max } = value;

        this.activeFilters = {
          ...currentFilters,
          price: {
            min: Number(min.replace(/(\$|\+)/gi, "")) * 100,
            max: max === -1 ? -1 : Number(max.replace(/(\$|\+)/gi, "")) * 100,
          },
        };

        //  console.log('Update Price', min, max);
      },
      handleAttributeUpdate({ type, value }) {
        const currentFilters = { ...this.activeFilters };
        const attributeFilters = currentFilters.attribute || {};

        attributeFilters[type] = value.length > 0 ? [...value] : null;
        currentFilters.attribute = attributeFilters;

        //  console.log('Handle Attribute Update:', { type, value, currentFilters, attributeFilters })

        this.activeFilters = { ...currentFilters };
      },
      handleVariantFilterUpdate({ type, value }) {
        const { variants } = this.activeFilters;
        const values = variants[type] || [];

        variants[type] = value;

        this.activeFilters = {
          ...this.activeFilters,
          variants: {
            ...variants,
          },
        };

        console.log("handleVariantFilterUpdate:", { type, value });
      },
      handleAvailabilityUpdate({ value, selected }) {
        this.activeFilters = {
          ...this.activeFilters,
          readyToShip: selected,
        };
      },
      handleTagUpdate({ phrase, tags }) {
        let phraseTest = new RegExp("^" + phrase, "i");
        let currentFilters = { ...this.activeFilters };

        let tagFilters = currentFilters.tags || [];

        tagFilters = tagFilters.filter((tag) => {
          return !phraseTest.test(tag);
        });

        tagFilters = tagFilters.concat(tags);

        this.activeFilters = {
          ...this.activeFilters,
          tags: tagFilters,
        };

        //  console.log('Handle Tag Update', tags, phrase, tagFilters);
      },
      tagsByPhrase(phrase) {
        const test = new RegExp(phrase, "ig");
        const applicableTags = [...this.collection_details.all_tags].filter(
          (tag) => {
            console.log("Run Test", { pass: test.test(tag), tag, test });

            return test.test(tag);
          }
        );

        // console.log('Tag By Phrase', {
        //   phrase,
        //   tags: window.theme.collection_details.all_tags,
        //   test,
        //   applicableTags,
        //   in_line: [...this.collection_details.all_tags].filter((tag) => {
        //     return test.test(tag);
        //   })
        // });

        return applicableTags;
      },
      toggleFilterBar(event) {
        this.filtersOpen = !this.filtersOpen;
      },
      fetchProducts() {},
      handleWishlistUpdate({ add, item }) {
        // console.log('Handle wishlist Update', add, item);

        if (add) {
          const withItem = [...this.wishlist_items];
          withItem.push(item);

          this.wishlist_items = [...withItem];
        } else {
          const withoutItem = [...this.wishlist_items].filter(
            (wishlistItem) => wishlistItem.empi !== item.empi
          );

          this.wishlist_items = [...withoutItem];
        }
      },
      wishlistStart() {
        // console.log('Collection Wishlist Items');

        window._swat.fetchWrtEventTypeET((r) => {
          // Get wishlist items
          // console.log('Wishlist Response', r);
          this.wishlist_items = [...r];
        });
      },
      handleScroll() {
        if (this.scTimer) return;
        this.scTimer = setTimeout(() => {
          // console.log('Handle Scroll Update', window.scrollY)
          this.scrollY = window.scrollY;
          clearTimeout(this.scTimer);
          this.scTimer = 0;
        }, 100);
      },
      toTop: function () {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      },
      fetchShopifyProduct(handle) {
        return fetch(`/products/${handle}?view=json`).then((res) => res.json());
      },
      async fetchNostoProducts() {
        if (!window.nostojs) return setTimeout(this.fetchNostoProducts, 500);

        // instantly disable autoload.
        nostojs((api) => api.setAutoLoad(false));

        function recommendations() {
          return new Promise(function (resolve, reject) {
            nostojs((api) => {
              api
                .defaultSession()
                .viewFrontPage()
                .setPlacements(api.placements.getPlacements())
                .load()
                .then((response) => resolve(response.campaigns))
                .catch((error) => reject(error));
            });
          });
        }

        const loadedRecommendations = await recommendations();
        const recommendationsKey = /(recently-viewed)/i.test(
          window.theme.collection_details.handle
        )
          ? "collection-recently-viewed"
          : "collection-page";

        const products =
          loadedRecommendations.recommendations[recommendationsKey].products;
        const vueProducts = [];

        // console.log('Loaded Recommendations', { loadedRecommendations, products });

        for (let i = 0; i < products.length; i++) {
          let nostoProduct = products[i];
          let handle = nostoProduct.url.split("/").reverse()[0];

          let product = await this.fetchShopifyProduct(handle);

          this.items.push({
            ...nostoProduct,
            ...product,
          });

          console.log("Handle", { handle, product });

          // zonos.config(z_store);
        }

        this.loading = false;
        setTimeout(() => {
          // zonos.config(z_store);
        }, 500);
        // console.log('Vue Products', { vueProducts, items: this.items });
      },
    },
    mounted() {
      const self = this;

      // console.log('Collection Mounted', this.loading, this.isEmpty, window.theme.collection_details);

      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }

      if (
        /(best-sellers-nosto|recently-viewed)/i.test(
          window.theme.collection_details.handle
        )
      ) {
        this.loading = true;
        this.fetchNostoProducts();
      }

      window.SwymCallbacks.push(function () {
        self.wishlistStart();
      });

      window.addEventListener("scroll", this.handleScroll);
    },
  });

  // Slick Initializer
  $(document).on("mouseenter", ".image-list.ready", function (event) {
    if (event.currentTarget.classList.contains("slick-initialized")) return;

    console.log("Mouse Enter Trigger?");
    // $(event.currentTarget).slick({
    //   draggable: true,
    // });
  });

  $(document).on(
    "click",
    ".image-list .slick-arrow, .image-list .slick-dots",
    function (event) {
      event.preventDefault();
    }
  );

  console.log("Collection Filters");
})();
